if (!customElements.get("f-cart-goal")) {
  class FCartGoal extends HTMLElement {
    constructor() {
      super();

      this.selectors = {
        cartDrawer: ".f-cart-drawer__inner",
        leftToSpend: "[data-left-to-spend]",
        itemsRemaining: "[data-items-remaining]",
        cartGoalTitle: ".f-cartgoal__title",
      };

      this.confettiShow = false;
      this.goalDone = false;
      this.goalType = this.dataset.goalType || "price";
      this.enableConfetti = this.dataset.enableConfetti === "true";

      if (this.goalType === "quantity") {
        this.goal = Number(this.dataset.cartGoal) || 0;
      } else {
        this.goal =
          Number(this.dataset.cartGoal) *
            Number(window.Shopify.currency.rate || 1) || 0;
        this.money_format = window.FoxThemeSettings.money_format;
      }
    }

    connectedCallback() {
      this.updateCartGoal(Number(this.dataset.cartTotal));

      window.FoxThemeEvents.subscribe(PUB_SUB_EVENTS.cartUpdate, (state) => {
        if (this.goalType === "quantity") {
          if (state.item_count !== undefined) {
            this.updateCartGoal(state.item_count);
          }
        } else {
          this.updateCartGoal(state.items_subtotal_price);
        }
      });

      window.FoxThemeEvents.subscribe(PUB_SUB_EVENTS.cartUpdate, async () => {
        const newCart = await window.FoxThemeCartHelpers.getState();
        if (newCart) {
          const value =
            this.goalType === "quantity"
              ? newCart.item_count
              : newCart.items_subtotal_price;
          this.updateCartGoal(value);
        }
      });

      this.confettiShow = this.goalDone;
    }

    updateCartGoal(value) {
      if (this.goalType === "quantity") {
        this._updateQuantityGoal(value);
      } else {
        this._updatePriceGoal(value);
      }
    }

    _updateQuantityGoal(itemCount) {
      if (itemCount > 0) {
        this.classList.remove("hidden");
      } else {
        this.classList.add("hidden");
      }

      this.cartTotal = itemCount;
      this.goalLeft = this.goal - itemCount;
      this.goalDone = this.goalLeft <= 0;
      this.percent = Math.min((itemCount * 100) / this.goal, 100);

      this.style.setProperty("--progress", `${this.percent}%`);

      if (this.goalDone) {
        this.classList.add("f-cartgoal--done", "shakeY");
      } else {
        const remaining = this.querySelector(this.selectors.itemsRemaining);
        if (remaining) {
          remaining.textContent = this.goalLeft;
        }
        this.classList.remove("f-cartgoal--done", "shakeY");
      }

      if (this.goalLeft <= 0 && this.enableConfetti) {
        this.showConfetti();
      } else {
        this.confettiShow = false;
      }
    }

    _updatePriceGoal(state) {
      if (state > 0) {
        this.classList.remove("hidden");
      } else {
        this.classList.add("hidden");
      }

      this.cartTotal = state / 100;
      this.goalLeft = this.goal - this.cartTotal;
      this.goalDone = this.goalLeft <= 0;
      this.percent = (this.cartTotal * 100) / this.goal;

      if (this.percent >= 100) this.percent = 100;

      this.style.setProperty("--progress", `${this.percent}%`);

      if (this.cartTotal >= this.goal) {
        this.classList.add("f-cartgoal--done", "shakeY");
        this.dataset.total = this.cartTotal;
      } else {
        let spend = (this.goal - this.cartTotal) * 100;
        const leftToSpend = this.querySelector(this.selectors.leftToSpend);
        if (leftToSpend) {
          leftToSpend.innerHTML = formatMoney(spend, this.money_format);
        }
        this.classList.remove("f-cartgoal--done", "shakeY");
        this.dataset.total = this.cartTotal;
      }

      if (this.goalLeft <= 0 && this.enableConfetti) {
        this.showConfetti();
      } else {
        this.confettiShow = false;
      }
    }

    showConfetti() {
      const cartDrawer = this.closest(this.selectors.cartDrawer);
      const cartTemplate = this.closest(".cart-template");

      if (!this.confettiShow && (cartDrawer || cartTemplate)) {
        setTimeout(() => {
          if (cartDrawer) {
            new window.FoxTheme.Confetti(cartDrawer);
          }
          if (cartTemplate) {
            new window.FoxTheme.Confetti(document.body);
          }
          this.confettiShow = true;
        }, 800);
      }
    }
  }

  customElements.define("f-cart-goal", FCartGoal);
}
